import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DropDownModel } from "../../../domain/model/common/dropDownModel";
import { ManagementCompany } from "../../../domain/model/enrollment/managementCompanies";
import { PropertyManagementCompany } from "../../../domain/model/properties/propertyManagementCompany";
import { CommonServices } from "../../../domain/service/commonService";
import { GooglePlacesService } from "../../../domain/service/GooglePlaceService";
import { PropertyService } from "../../../domain/service/propertyService";

@Component({
  selector: "app-management-company-add",
  templateUrl: "./management-company-add.component.html",
  styleUrl: "./management-company-add.component.css",
})
export class ManagementCompanyAddComponent implements OnInit {
  dialogRef = inject<DialogRef<ManagementCompany>>(DialogRef<ManagementCompany>);
  constructor(
    private googlePlacesService: GooglePlacesService,
    private commonServices: CommonServices,
    private propertyService: PropertyService
  ) {}
  states: DropDownModel[] = [];
  suggestions: any[] = [];
  propertySuggestions: PropertyManagementCompany[] = [];
  data = inject(DIALOG_DATA);

  companyForm = new FormGroup({
    propertyName: new FormControl(this.data.company.companyName, [Validators.required, Validators.maxLength(200)]),
    streetAddress: new FormControl(this.data.company.streetAddress, [Validators.required, Validators.maxLength(200)]),
    aptUnitSuite: new FormControl(this.data.company.aptUnitSuite, [Validators.maxLength(200)]),
    city: new FormControl(this.data.company.city, [Validators.required, Validators.maxLength(200)]),
    state: new FormControl(this.initialStateValue(), [Validators.required]),
    zipCode: new FormControl(this.data.company.zipCode, [
      Validators.required,
      Validators.maxLength(12),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
    ]),
  });

  ngOnInit(): void {
    this.getAllStates();
    this.onStreetAddressChange();
    this.onRentalPropertyBusinessChange();
  }
  initialStateValue() {
    return this.data.company.state === 0 ? "" : this.data.company.state;
  }
  private onRentalPropertyBusinessChange() {
    this.companyForm.get("propertyName")?.valueChanges.subscribe((value) => {
      if (value) {
        this.propertyService.getAutoCompleteProperty(value).subscribe({
          next: (response) => {
            this.propertySuggestions = response;
          },
          error: (error) => {
            this.propertySuggestions = [];
          },
          complete: () => {
            //this.propertySuggestions = [];
          },
        });
      } else {
        this.propertySuggestions = [];
      }
    });
  }
  getAllStates() {
    this.commonServices.getAllState(233).subscribe((data) => {
      this.states = data.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  onStreetAddressChange() {
    this.companyForm.get("streetAddress")?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });
  }
  save() {
    let company: ManagementCompany = {
      companyName: this.companyForm.get("propertyName")?.value ?? "",
      streetAddress: this.companyForm.get("streetAddress")?.value ?? "",
      aptUnitSuite: this.companyForm.get("aptUnitSuite")?.value ?? "",
      city: this.companyForm.get("city")?.value ?? "",
      state: this.companyForm.get("state")?.value ?? 0,
      zipCode: this.companyForm.get("zipCode")?.value ?? "",
      internalId: this.data.company.internalId,
      stateName:
        this.states.find((e) => e.id == Number.parseInt(this.companyForm.get("state")?.value ?? "0"))?.name ?? "",
      id: this.data.company.id,
      accountId: this.data.company.accountId,
      rentalPropertyId: this.data.company.rentalPropertyId,
    };
    this.dialogRef.close(company);
  }
  async selectProperty(place: any) {
    this.companyForm.get("propertyName")?.setValue(place.name);
  }
  async selectPlace(place: any) {
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);

    const locationDetails = this.googlePlacesService.extractLocationDetails(details);

    const { zip = "", city = "", stateCode, address = "" } = locationDetails;
    this.companyForm.get("zipCode")?.setValue(zip);
    this.companyForm.get("city")?.setValue(city);

    if (stateCode) {
      let stateId = this.states.find((e) => e.iso2 == stateCode)?.id ?? 0;
      this.companyForm.get("state")?.setValue(stateId);
    }

    this.companyForm.get("streetAddress")?.setValue(address ?? place.description);
    this.companyForm.get("streetAddress")?.updateValueAndValidity();
    this.companyForm.get("streetAddress")?.markAsUntouched();
    this.suggestions = [];
  }
}
